export enum Path {
  PoCwpSelection = '',
  PolicyTypeSelection = 'policy-type-selection',
  PolicyInfoInput = 'policy-info-input',
  ReviewInformation = 'review-information',
  SelectUsername = 'select-username',
  InputUsername = 'input-username',
  InputOtp = 'input-otp',
  SetPassword = 'set-password',
  Success = 'success',
  Error = 'error',
}
